export default "__VITE_ASSET__DZN6sPCl__"